import { render, staticRenderFns } from "./Hoofdrichtingen.vue?vue&type=template&id=a3340c5a&"
import script from "./Hoofdrichtingen.vue?vue&type=script&lang=js&"
export * from "./Hoofdrichtingen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports